import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import DesignUnderLine from '../../components/ExcerciseTypes/Design/DesignUnderLine';


const json = {

  1: { // Exercise num
    unit: 'Unit 4',
    id: 'WB3-U4-P30-E1',
    audio: '',
    video: '',
    component: DesignUnderLine,
    exerciseKey: 'img/FriendsPlus/Page30/E1/Key/answerKey.png',
    titleImage: '',
    totalInput: 3,
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page30/E1/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page30/E1/2.jpg' },
        { url: 'img/FriendsPlus/Page30/E1/3.jpg', input: 1, },
        { url: 'img/FriendsPlus/Page30/E1/4.jpg', input: 1, isCorrect: true },
        { url: 'img/FriendsPlus/Page30/E1/5.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page30/E1/6.jpg' },
        { url: 'img/FriendsPlus/Page30/E1/7.jpg', input: 2, isCorrect: true },
        { url: 'img/FriendsPlus/Page30/E1/8.jpg', input: 2, },
        { url: 'img/FriendsPlus/Page30/E1/9.jpg' },
        { url: 'img/FriendsPlus/Page30/E1/10.jpg', input: 3, },
        { url: 'img/FriendsPlus/Page30/E1/11.jpg', input: 3, isCorrect: true },
        { url: 'img/FriendsPlus/Page30/E1/12.jpg' },
      ],

    ]
  },
  2: { // Exercise num
    unit: 'Unit 4',
    id: 'WB3-U4-P30-E2',
    audio: '',
    video: '',
    component: D1,
    textAlign: 'center',
    padding: 0,
    maxLength: 1,
    exerciseKey: 'img/FriendsPlus/Page30/E2/Key/answerKey.png',
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page30/E2/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page30/E2/2.jpg' },
        { url: 'img/FriendsPlus/Page30/E2/3.jpg', input: true, answer: "c" },
        { url: 'img/FriendsPlus/Page30/E2/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page30/E2/5.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page30/E2/6.jpg' },
        { url: 'img/FriendsPlus/Page30/E2/7.jpg', input: true, answer: "a" },
        { url: 'img/FriendsPlus/Page30/E2/8.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page30/E2/9.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page30/E2/10.jpg' },
        { url: 'img/FriendsPlus/Page30/E2/11.jpg', input: true, answer: "d" },
        { url: 'img/FriendsPlus/Page30/E2/12.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page30/E2/13.jpg' },
      ],



    ],
  },
  3: { // Exercise num
    unit: 'Unit 4',
    id: 'WB3-U4-P30-E3',
    audio: '',
    video: '',
    component: D1,
    checkUppercase: true,
    exerciseKey: 'img/FriendsPlus/Page30/E3/Key/answerKey.png',
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page30/E3/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page30/E3/2.jpg' },
        { url: 'img/FriendsPlus/Page30/E3/3.jpg', input: true, answer: "computers " },
        { url: 'img/FriendsPlus/Page30/E3/4.jpg' },
        { url: 'img/FriendsPlus/Page30/E3/5.jpg', input: true, answer: "computer room" },
        { url: 'img/FriendsPlus/Page30/E3/6.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page30/E3/7.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page30/E3/8.jpg' },
        { url: 'img/FriendsPlus/Page30/E3/9.jpg', input: true, answer: "We have pictures in the art room." },
        { url: 'img/FriendsPlus/Page30/E3/10.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page30/E3/11.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page30/E3/12.jpg' },
        { url: 'img/FriendsPlus/Page30/E3/13.jpg', input: true, answer: "We have books in the classroom." },
        { url: 'img/FriendsPlus/Page30/E3/14.jpg' },
      ],




    ],
  },


}

export default json;